import React, { useState } from 'react';
import { ProductImage } from '../../types';
import './ImageGallery.css';

interface ImageGalleryProps {
  images: ProductImage[];
  productName: string;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({ images, productName }) => {
  const [selectedImage, setSelectedImage] = useState(0);

  const handlePrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="image-gallery">
      {images.length > 1 && (
        <div className="thumbnail-list">
          {images.map((image, index) => (
            <div
              key={image.id}
              className={`thumbnail ${index === selectedImage ? 'active' : ''}`}
              onClick={() => setSelectedImage(index)}
            >
              <img src={image.image} alt={`${productName} thumbnail ${index + 1}`} />
            </div>
          ))}
        </div>
      )}

      <div className="main-image-container">
        <div className="main-image">
          <img
            src={images[selectedImage].image}
            alt={`${productName} - ${selectedImage + 1}`}
          />
        </div>

        {images.length > 1 && (
          <>
            <button className="nav-btn prev" onClick={handlePrev} aria-label="Previous image">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <button className="nav-btn next" onClick={handleNext} aria-label="Next image">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ImageGallery;
